import{Component}from"@theme/component";import{fetchConfig,debounce,onAnimationEnd,prefersReducedMotion,resetShimmer}from"@theme/utilities";import{morphSection,sectionRenderer}from"@theme/section-renderer";import{ThemeEvents,CartUpdateEvent,QuantitySelectorUpdateEvent,CartAddEvent,DiscountUpdateEvent}from"@theme/events";import{cartPerformance}from"@theme/performance";

// ============================================
// BXGX CONFIG - Yahan apne offers add karo
// ============================================
const BXGX_OFFERS = [
  {
    variantId: 52382338842929,  // Cream of Coco Soap Pack of 3
    buy: 3,
    get: 3
  },
  // Aur offers add karne ke liye:
  // { variantId: VARIANT_ID, buy: 1, get: 1 },
  // { variantId: VARIANT_ID, buy: 2, get: 2 },
];
// ============================================

let isSyncing = false;

async function syncBXGX() {
  if (isSyncing) return;
  isSyncing = true;

  try {
    const cart = await fetch('/cart.js').then(r => r.json());

    for (const offer of BXGX_OFFERS) {
      let paidQty = 0, freeQty = 0, freeLineKey = null;

      cart.items.forEach(item => {
        if (item.variant_id == offer.variantId) {
          if (item.properties && item.properties['_free_item'] === 'true') {
            freeQty = item.quantity;
            freeLineKey = item.key;
          } else {
            paidQty += item.quantity;
          }
        }
      });

      const sets = Math.floor(paidQty / offer.buy);
      const neededFree = sets * offer.get;

      if (neededFree > freeQty) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: offer.variantId,
              quantity: neededFree - freeQty,
              properties: { '_free_item': 'true', '🎁 Free Item': '✓' }
            }]
          })
        });
        isSyncing = false;
        location.reload();
        return;
      } else if (neededFree < freeQty && freeLineKey) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: freeLineKey, quantity: neededFree })
        });
        isSyncing = false;
        location.reload();
        return;
      }
    }
  } catch(e) {
    console.error('BXGX sync error:', e);
  }

  isSyncing = false;
}

// Product page "Add to bag" button pe listener
function attachAddToCartListeners() {
  document.querySelectorAll('[data-cart-add], form[action="/cart/add"] button[type="submit"], .add-to-cart, product-form-component').forEach(el => {
    el.addEventListener('click', () => setTimeout(syncBXGX, 1500), { once: false });
  });
}

class CartItemsComponent extends Component{#e=debounce(this.#t,300).bind(this);connectedCallback(){super.connectedCallback(),document.addEventListener(ThemeEvents.cartUpdate,this.#n),document.addEventListener(ThemeEvents.discountUpdate,this.handleDiscountUpdate),document.addEventListener(ThemeEvents.quantitySelectorUpdate,this.#e)}disconnectedCallback(){super.disconnectedCallback(),document.removeEventListener(ThemeEvents.cartUpdate,this.#n),document.removeEventListener(ThemeEvents.quantitySelectorUpdate,this.#e)}#t(e){const{quantity:t,cartLine:n}=e.detail;if(!n)return;if(0===t)return this.onLineItemRemove(n);this.updateQuantity({line:n,quantity:t,action:"change"});const r=this.refs.cartItemRows[n-1];if(!r)return;const o=r.querySelector("text-component");o?.shimmer()}onLineItemRemove(e){this.updateQuantity({line:e,quantity:0,action:"clear"});const t=this.refs.cartItemRows[e-1];if(!t)return;[t,...this.refs.cartItemRows.filter((e=>e.dataset.parentKey===t.dataset.key))].forEach((e=>{const t=()=>e.remove();if(prefersReducedMotion())return t();e.style.setProperty("--row-height",`${e.clientHeight}px`),e.classList.add("removing"),onAnimationEnd(e,t)}))}updateQuantity(e){const t=cartPerformance.createStartingMarker(`${e.action}:user-action`);this.#r();const{line:n,quantity:r}=e,{cartTotal:o}=this.refs,i=document.querySelectorAll("cart-items-component"),s=new Set([this.sectionId]);i.forEach((e=>{e instanceof HTMLElement&&e.dataset.sectionId&&s.add(e.dataset.sectionId)}));const a=JSON.stringify({line:n,quantity:r,sections:Array.from(s).join(","),sections_url:window.location.pathname});o?.shimmer(),fetch(`${Theme.routes.cart_change_url}`,fetchConfig("json",{body:a})).then((e=>e.text())).then((e=>{const t=JSON.parse(e);if(resetShimmer(this),t.errors)return void this.#o(n,t);const r=(new DOMParser).parseFromString(t.sections[this.sectionId],"text/html"),o=r.querySelector('[ref="cartItemCount"]')?.textContent,i=o?parseInt(o,10):0;this.dispatchEvent(new CartUpdateEvent({},this.sectionId,{itemCount:i,source:"cart-items-component",sections:t.sections}));morphSection(this.sectionId,t.sections[this.sectionId]);setTimeout(syncBXGX, 800)})).catch((e=>{console.error(e)})).finally((()=>{this.#i(),cartPerformance.measureFromMarker(t)}))}handleDiscountUpdate=e=>{this.#n(e)};#o=(e,t)=>{const n=this.refs.quantitySelectors[e-1],r=n?.querySelector("input");if(!r)throw new Error("Quantity input not found");r.value=r.defaultValue;const o=this.refs[`cartItemError-${e}`],i=this.refs[`cartItemErrorContainer-${e}`];if(!(o instanceof HTMLElement))throw new Error("Cart item error not found");if(!(i instanceof HTMLElement))throw new Error("Cart item error container not found");o.textContent=t.errors,i.classList.remove("hidden")};#n=e=>{if(e instanceof DiscountUpdateEvent)return void sectionRenderer.renderSection(this.sectionId,{cache:!1});if(e.target===this)return;const t=e.detail.data.sections?.[this.sectionId];t?morphSection(this.sectionId,t):sectionRenderer.renderSection(this.sectionId,{cache:!1})};#r(){this.classList.add("cart-items-disabled")}#i(){this.classList.remove("cart-items-disabled")}get sectionId(){const{sectionId:e}=this.dataset;if(!e)throw new Error("Section id missing");return e}}customElements.get("cart-items-component")||customElements.define("cart-items-component",CartItemsComponent);

// Sab events pe sync
document.addEventListener(CartAddEvent.eventName, () => setTimeout(syncBXGX, 1500));
document.addEventListener(ThemeEvents.cartUpdate, () => setTimeout(syncBXGX, 1500));
document.addEventListener('DOMContentLoaded', () => {
  syncBXGX();
  attachAddToCartListeners();
});